"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./ViewerTableRow.css");
const mithril_1 = __importDefault(require("mithril"));
const classnames_1 = __importDefault(require("classnames"));
const dayjs_1 = __importDefault(require("dayjs"));
require("../Act");
require("../strava-icons.css");
function formatDuration(secs) {
    let mins = Math.round(secs / 60);
    let mPart = mins % 60;
    let hPart = Math.floor(mins / 60);
    if (hPart > 0) {
        return [hPart, (0, mithril_1.default)('.ViewerTableRow-unit', 'h'), `00${mPart}`.slice(-2), (0, mithril_1.default)('.ViewerTableRow-unit', 'm')];
    }
    else {
        return [mPart, (0, mithril_1.default)('.ViewerTableRow-unit', 'm')];
    }
}
const ViewerTableRow = () => {
    return {
        view: ({ attrs: { act, isVisible, isHovered, isHoveredDirectly, isSelected, attrs } }) => {
            return (0, mithril_1.default)('.ViewerTableRow', Object.assign({ id: `ViewerTableRow-${act.data.id}`, class: (0, classnames_1.default)({ invisible: !isVisible, hovered: isHovered, "hovered-directly": isHoveredDirectly, selected: isSelected }) }, attrs), (0, mithril_1.default)('.ViewerTableRow-left', { class: `app-icon icon-${act.data.type.toLowerCase()}`, title: act.data.type }), (0, mithril_1.default)('.ViewerTableRow-right', (0, mithril_1.default)('.ViewerTableRow-name', act.data.name, act.latLngs === undefined && [' ', (0, mithril_1.default)('span.ViewerTableRow-no-map', '[no map]')]), (0, mithril_1.default)('.ViewerTableRow-date', (0, dayjs_1.default)(act.data.start_date).format('YYYY-MM-DD dd')), (0, mithril_1.default)('.ViewerTableRow-stat', formatDuration(act.data.moving_time)), (0, mithril_1.default)('.ViewerTableRow-stat', (act.data.distance / 1609.34).toFixed(1), (0, mithril_1.default)('.ViewerTableRow-unit', 'mi')), (0, mithril_1.default)('.ViewerTableRow-stat', (act.data.total_elevation_gain * 3.28084).toFixed(0), (0, mithril_1.default)('.ViewerTableRow-unit', 'ft')), (0, mithril_1.default)('a.ViewerTableRow-strava-link', {
                href: `https://www.strava.com/activities/${act.data.id}`,
                onclick: (ev) => ev.stopPropagation(),
                target: '_blank',
            }, (0, mithril_1.default)('img.ViewerTableRow-strava-link-img', { src: 'strava-2.svg' }))));
        },
    };
};
exports.default = ViewerTableRow;
